import type { FunctionComponent } from "react";

import type { Props as AdSlotProps } from "~/components/advertisement/ad-slots/ad-slot";
import { AdSlot } from "~/components/advertisement/ad-slots/ad-slot";
import { useStoryStyleContext } from "~/components/story-style/contexts";
import { AdCardIndexList } from "~/components/story-style/story-style-layout/consts";
import { AdFloatClickableArea } from "~/components/story-style/story-style-layout/story-style-ad-card/ad-float-clickable-area";

import { AdCardContainer, AdSlotContainer } from "./styles";

type Props = {
  breakpoint?: AdSlotProps["breakpoint"];
  className?: string;
};

export const StoryStyleAdCard: FunctionComponent<Props> = ({ breakpoint, className }) => {
  const { currentPageIndex, handleGoToNextPage, handleGoToPreviousPage } = useStoryStyleContext();
  return (
    <AdCardContainer className={className}>
      <AdFloatClickableArea
        handleGoToNextPage={handleGoToNextPage}
        handleGoToPreviousPage={handleGoToPreviousPage}
      />
      {AdCardIndexList.map((adPageIndex, index) => (
        <AdSlotContainer
          $isHidden={currentPageIndex !== adPageIndex}
          key={`full-page-ad-${index}}`}
        >
          <AdSlot
            adUnit="m_oop3"
            breakpoint={breakpoint}
            sizes={[[320, 480], "fluid"]}
            targeting={{
              pos: `card_oop${index + 1}`,
            }}
            zone="interstitial_style/card"
          />
        </AdSlotContainer>
      ))}
    </AdCardContainer>
  );
};

StoryStyleAdCard.displayName = "StoryStyleAdCard";
